import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <div className="bg-[var(--sci-bg)] min-h-screen flex flex-col">
      <SEO
        title="404 · Page Not Found"
        description="The page you requested could not be found on International Sci Ink Press."
        path="/404"
        noindex
      />
      <Navbar />
      <section className="flex-1 pt-32 md:pt-40 pb-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="overline text-[var(--sci-teal)] mb-5">
            · Error 404
          </div>
          <h1 className="font-serif-display text-5xl md:text-7xl text-[var(--sci-navy)] tracking-tight leading-[0.98]">
            Not in the <em className="not-italic text-[var(--sci-teal)]">archive</em>.
          </h1>
          <p className="mt-6 text-[var(--sci-text-muted)] leading-relaxed text-base md:text-lg max-w-xl">
            The page you requested doesn't exist or has been moved. Try one of
            the destinations below, or use the search (Ctrl/Cmd + K) to find
            anything across the publisher.
          </p>
          <div className="mt-10 grid sm:grid-cols-2 gap-3 max-w-lg">
            <Link
              to="/"
              data-testid="notfound-home"
              className="btn-primary inline-flex items-center justify-center gap-2 px-5 py-3 text-sm"
            >
              <ArrowLeft size={14} />
              Back to publisher
            </Link>
            <Link
              to="/editorial-board/ijmrcr"
              data-testid="notfound-board"
              className="btn-secondary inline-flex items-center justify-center gap-2 px-5 py-3 text-sm"
            >
              Editorial Board
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
